import React, { ReactElement } from 'react';
import Link from 'next/link';
import classNames from 'classnames/bind';
import styles from 'sections/Events/GlobalFreightSummit2023/components/SectionDescription/SectionDescription.module.scss';

const cn = classNames.bind(styles);

const SectionDescription = (): ReactElement => {
  return (
    <section className={cn('description')}>
      <div className={cn('container')}>
        <h3 className={cn('description__title')}>description</h3>
        <div className={cn('description__content')}>
          <div className={cn('description__content-box')}>
            <div className={cn('description__paragraphs-box')}>
              <p className={cn('description__paragraphs-text')}>
                As global supply chains continue to face unprecedented challenges, conflated by recent geopolitical
                tensions, logistics and freight industry stakeholders are actively seeking innovations and solutions to
                these major complex global challenges.
              </p>
              <p className={cn('description__paragraphs-text')}>
                The Global Freight Summit is DP World’s vision to create a platform to convene the influential minds
                from the <Link href="/">international freight</Link> forwarding and supply chain communities. An event
                that brings industry leaders and the global freight community together to discuss the pressing
                challenges and issues keeping them awake at night.
              </p>
            </div>
          </div>
          <div className={cn('description__content-box')}>
            <div className={cn('description__paragraphs-box')}>
              <p className={cn('description__paragraphs-text')}>
                This November DP World will again convene the international freight forwarding and supply chain
                communities. Under the theme: MAKING THE FUTURE SUPPLY CHAIN A REALITY the summit will explore how all
                industry stakeholders can take action together to build solutions to the major challenges faced by the
                sector.
              </p>
              <p className={cn('description__paragraphs-text', 'bold')}>
                The first 500 registrations for Global Freight Summit 2023 will secure their place for free (full
                price tickets $500).
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SectionDescription;